<template lang="pug">
router-view
</template>

<script>
// import router from '@/router'
import UserItem from '@/models/UserItem'

export default {
  props: {
    userItem: {
      type: UserItem,
      required: true
    }
  },
  setup (props) {
    // if (!props.userItem.bought) router.replace({ name: 'VprContents' })
  }
}
</script>
